<template>
  <header id="main-header" ref="headRef">
    <nav class="navbar navbar-expand-xl">
      <div class="d-flex user_profile">
        <div class="user_image">
          <router-link to="/" class="site_logo">
            <img src="images/logo.png" class="img-fluid" />
          </router-link>
        </div>
      </div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#collapsibleNavId"
        @click="showMenu = !showMenu"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="#ffffff"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M4 6h16M4 12h16M4 18h7"
          />
        </svg>
      </button>
      <div
        class="collapse navbar-collapse"
        :class="showMenu ? 'show' : ''"
        id="collapsibleNavId"
      >
        <ul class="navbar-nav ml-auto mt-0 align-items-center">
          <li class="nav-item text-white wood-ribbon" v-if="username=='wildwesttest'">
            <a href="#" class="nav-link" @click="unlocked()">
              <span class="font-weight-bold"
                >Clear Ram</span
              ></a
            >
          </li>
          <li class="nav-item text-white wood-ribbon">
            <a href="#" class="nav-link" @click="showGameItems('food')">
              <img src="images/fooditems.webp" class="img-fluid img_resize" />
              <span class="font-weight-bold"
                >&nbsp;&nbsp;{{ totalFood }}</span
              ></a
            >
          </li>
          <li class="nav-item text-white wood-ribbon">
            <a href="#" class="nav-link" @click="showGameItems('item')">
              <img src="images/gameItems.png" class="img-fluid img_resize" />
              <span class="font-weight-bold"
                >&nbsp;&nbsp;{{ totalGameItems }}</span
              ></a
            >
          </li>
          <li class="nav-item text-white wood-ribbon">
            <a href="#" class="nav-link" @click="showModal('deposit')">
              <img src="images/scoin.png" class="img-fluid img-coin" /> WWS
              <span class="font-weight-bold">{{ wwsToken }}</span></a
            >
          </li>
          <li class="nav-item text-white wood-ribbon">
            <a href="#" class="nav-link" @click="showModal('deposit')">
              <img src="images/gcoin.png" class="img-fluid img-coin" /> WWG
              <span class="font-weight-bold">{{ wwgToken }}</span></a
            >
          </li>
          <li class="nav-item text-white">
            <a href="#" class="nav-link"> {{ username }}</a>
          </li>
          <li class="nav-item text-white dropdown">
            <a
              href="Javascript:void(0)"
              class="nav-link"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              @click="isShow = !isShow"
            >
              <i class="bi bi-gear"></i>
            </a>
            <ul class="dropdown-menu" :class="isShow ? 'show' : ''">
              <li>
                <a class="dropdown-item" href="#" @click="showModal('deposit')"
                  >Deposit</a
                >
              </li>
              <li>
                <a class="dropdown-item" href="#" @click="showModal('withdraw')"
                  >Withdraw</a
                >
              </li>
              <li>
                <a class="dropdown-item" href="#" @click="showModal('rpc')"
                  >Rpc Server</a
                >
              </li>

              <li>
                <a class="dropdown-item" href="#" @click="logout()">Logout</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  </header>
  <WalletInfoModal
    v-if="showDeposit"
    :showModel="showDeposit"
    v-on:w-modal-hide-click="showDeposit = false"
  />
  <GameItems
    v-if="gameItemModal"
    :itemName="itemName"
    :showModel="gameItemModal"
    v-on:w-modal-hide-click="gameItemModal = false"
  />

  <RpcModal v-if="showRpc" v-on:w-modal-hide-click="showRpc = false" />
</template>
<script>
import { mapGetters } from "vuex";
import router from "../router";
import RpcModal from "./Modal/RpcModal.vue";
import WalletInfoModal from "@/components/Modal/WalletInfoModal";
import GameItems from "@/components/Modal/GameItems";
import ApiService from "../services";
import moment from "moment";
export default {
  name: "Navbar",
  components: {
    RpcModal,
    WalletInfoModal,
    GameItems,
  },
  computed: {
    ...mapGetters([
      "loaded",
      "wwsToken",
      "wwgToken",
      "totalGameItems",
      "totalFood",
    ]),
  },
  data() {
    return {
      isOpen: false,
      isShow: false,
      showMenu: false,
      showRpc: false,
      showDeposit: false,
      gameItemModal: false,
      refillEnergy: false,
      username: "",
      dropdownItem: [
        {
          title: "Logout",
          link: "#",
        },
      ],
    };
  },
  created() {
    ApiService.getHeaderContents();
    this.username = localStorage.getItem("wax_user");
  },
  methods: {
    getTimeLeft(stake) {
      if (stake) {
        let cUTC = moment.utc(new Date()).format("YYYY-MM-DD HH:mm:ss");
        let endDate = moment(stake.last_claimed)
          .add(1, "hours")
          .format("YYYY-MM-DD HH:mm:ss");
        this.expired = moment(cUTC).isAfter(moment(endDate));
      }
    },
    logout: () => {
      localStorage.clear();
      router.push("/login");
    },
    async unlocked() {
      this.loading = true;
      const data = {
        contract: process.env.VUE_APP_CONTRACT,
        action: "auto.unlock",
        data: {},
      };
      await ApiService.transaction(
        data,
        (res) => {
          if (res.processed) {
            ApiService.successMsg();
          }
        },
        (error) => {
          ApiService.errorMsg(error);
        }
      );
    },
    showModal(modal) {
      switch (modal) {
        case "deposit":
          this.showDeposit = true;
          this.isOpen = false;
          this.isShow = false;
          break;
        case "gameItems":
          this.gameItemModal = true;
          this.isOpen = false;
          this.isShow = false;
          break;
        case "rpc":
          this.showRpc = true;
          this.isOpen = false;
          this.isShow = false;
          break;
      }
    },
    showGameItems(item) {
      this.gameItemModal = true;
      this.isOpen = false;
      this.isShow = false;
      this.itemName = item;
    },
  },
};
</script>
<style scoped>
.wood-ribbon {
  background: url("/images/wood-ribbon.png") no-repeat;
  background-size: 100% 100%;
  height: 40px;
  text-align: center;
  margin-right: 20px;
}
.wood-ribbon a {
  display: block;
  font-size: 17px;
  padding: 5px 36px 0 30px !important;
  margin: 0px;
}
.img_resize {
  width: 25px;
}
/* .user_image img {
  width: 80px;
  height: 80px;
} */
.progress {
  height: 6px;
}
.user_profile {
  width: 20%;
  justify-content: space-around;
  align-items: center;
  /*background: #565656;*/
  /* padding: 8px 20px; */
  border-radius: 10px;
}
.claim_btn {
  background: #eeac33;
  padding: 4px 16px !important;
  border-radius: 8px;
}
.img-coin {
  width: 25px;
}
.claim_btn:hover {
  color: #fff;
}
.dropdown-menu {
  left: inherit;
  right: 40px;
  top: 39px;
}
.navbar-toggler {
  height: 100%;
}
.navbar-toggler svg {
  width: 50px;
  color: #ffffff;
}
@media (max-width: 992px) {
  .wood-ribbon {
    width: 100%;
    margin-right: 0;
    margin-bottom: 5px;
    /* height: 100%; */
  }
}
</style>